let ja = {
    "translation" : {
        "sign_in" : "ログイン",
        "sign_up" : "利用登録",
        "top"     : "トップへ"
    }
};

export default ja;
